const UserExistence = Object.freeze({
  EXISTS: "exists",
  NOT_EXISTS: "not_exists",
  LOADING: "loading",
});

export default UserExistence;